import React from 'react'
import styled from 'styled-components'

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear()
  }

  return (
    <Wrapper>
      <div>
        <div className="container">
          <InnerWrapper className="flexSpaceCenter">
            <StyleP className="font12">
              © {getCurrentYear()} The Painter Guy
              | All rights reserved |{' '}
              <a href="tel:+64273658483">
                +64 27 365 8483
              </a>
            </StyleP>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const InnerWrapper = styled.div`
  padding: 20px 0;
  @media (max-width: 550px) {
    flex-direction: row;
  }
`
const StyleP = styled.p`
  a {
    color: #333;
    text-decoration: none;
  }
  i {
    margin-right: 5px;
  }
  @media (max-width: 550px) {
    text-align: center;
  }
`
